import { ContactConstants } from './contacts';
import { EquipmentConstants } from './equipment';
import { TeamDriverConstants } from './teamDriver';

export const OperationsConstants = {
  ...ContactConstants,
  ...EquipmentConstants,
  ...TeamDriverConstants,
};
